import { useState } from 'react'
import { Create, useTranslate } from 'react-admin'

import { BackFromEditorButton } from 'components/common/BackFromEditorButton'

import SchoolClassRepresentativeForm from './SchoolClassRepresentativeForm'

const SchoolClassRepresentativeCreate = (props) => {
    const translate = useTranslate()
    const [isPristineForm, setIsPristineForm] = useState(true)

    return (
        <>
            <BackFromEditorButton
                isPristineForm={isPristineForm}
                backToRouteURL="/schoolClassRepresentative"
            />
            <Create title={translate('manager.resources.contactPersons.create')} {...props}>
                <SchoolClassRepresentativeForm
                    isPristineForm={isPristineForm}
                    setIsPristineFormCallback={setIsPristineForm}
                />
            </Create>
        </>
    )
}

export default SchoolClassRepresentativeCreate
